<template>
  <v-fab-transition>><!--  outlined color="onprimary" -->
    <v-btn v-show="showIcon" @click="onClick" outlined color="onprimary" large class="wgu-action-button smallMargin adjustPadding buttonBorder" :title="$t('wgu-wrclink.title')">
      <!--<v-icon large color="onprimary">{{ icon }}</v-icon>-->
      <v-icon class="d-md-none">open_in_new</v-icon>
      <span  color="onprimary" class="d-none d-lg-flex onprimary--text">{{ $t('wgu-wrclink.label') }}</span>
      <span  color="onprimary" class="d-none d-md-flex d-lg-none onprimary--text">{{ $t('wgu-wrclink.shortLabel') }}</span>
    </v-btn>
  </v-fab-transition>
</template>

<script>

import { WguEventBus } from '../../../src/WguEventBus'
import { Mapable } from '../../../src/mixins/Mapable';

export default {
  name: 'wgu-wrclink',
  mixins: [Mapable],
  props: {
    icon: { type: String, required: false, default: 'zoom_out_map' }
  },
  created () {
    WguEventBus.$on('wrcLink_update_Building', this.updateBuildingID);
  },
  data () {
    return {
      iconSize: 'large',
      wrcURL: this.$appConfig.modules['wgu-WRCLink'].wrcLinkURL,
      buildingID: null,
      showIcon: false
    }
  },
  methods: {
    onClick () {
      // derive correct initial zoom and center
      // console.log(this.wrcURL + this.buildingID)
      window.open(this.wrcURL + this.buildingID, 'WRCWindow')
    },
    updateBuildingID (buildingId) {
      this.buildingID = buildingId;
      if (buildingId < 0) {
        this.showIcon = false;
      } else {
        this.showIcon = true;
      }
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .smallMargin {
  margin-right: 6px;
  margin-left: 6px;
 }

 .buttonBorder {
    /* border: solid 1px #0061A0 !important; */
    border: solid 2px rgb(127, 176, 208)!important;
  }

 @media (max-width: 600px) {
  .adjustPadding {
    padding: 0 4px !important;
    min-width: 0px !important;
  }
}

@media (max-width: 1200px) {
  .adjustPadding {
    padding: 0 8px !important;
    letter-spacing: 0px;
  }
}

</style>
